import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=13643d72&lang=html&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Spinner.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "417e1628"
  
)

export default component.exports